import {ICue} from "../components/localization/LocalizedSubtitles";

function lpad(value: number, padding: number) {
    return (new Array(padding + 1).join("0") + value).slice(-padding);
}
function makeCueTime(offset: number) {
    const minutes = Math.floor(offset / 60000);
    const seconds = Math.floor((offset - minutes * 60000) / 1000);
    const milliseconds = offset - minutes * 60000 - seconds * 1000;

    return `${lpad(minutes, 2)}:${lpad(seconds, 2)}.${lpad(milliseconds, 3)}`;
}
function makeCue(cue: ICue) {
    return `${makeCueTime(cue.start)} --> ${makeCueTime(cue.stop)}\n${cue.text}`
}
export function makeWebVTTFile(cues: ICue []) {
    return ["WEBVTT", ...cues.map(makeCue)].join("\n\n");
}